export const CONTEXT_MODAL_POSITION = {
    MODAL_UP: 'MODAL_UP',
    MODAL_DOWN: 'MODAL_DOWN'
};



// WEBPACK FOOTER //
// ./components/context-modal/context-modal-constants.js